import { toast, ToastPosition } from 'react-toastify';
import axios from 'axios';

import CustomToast from "./CustomToast";

const TYPE_SUCCESS = 'SUCCESS';
const TYPE_INFO = 'INFO';
const TYPE_WARN = 'WARN';
const TYPE_ERROR = 'ERROR';

class ToastUtil {

    static success(title: string, message?: string) {
        this.show(TYPE_SUCCESS, title, message);
    }

    static info(title: string, message?: string) {
        this.show(TYPE_INFO, title, message);
    }

    static warn(title: string, message?: string) {
        this.show(TYPE_WARN, title, message);
    }

    static error(title: string, message?: string) {
        this.show(TYPE_ERROR, title, message);
    }

    static successRaw(title: string, message?: string | any[]) {
        this.show(TYPE_SUCCESS, title, message, true);
    }

    static errorRaw(title: string, message?: string | any[], autoCloseDelay = 5000) {
        this.show(TYPE_ERROR, title, message, true, autoCloseDelay);
    }

    static errorApi(error: any, title = 'Có lỗi xảy ra', autoCloseDelay = 5000) {
        if (axios.isCancel(error)) {
            // Do nothing if request was cancelled
            return;
        }
        let message = null;
        let messageId = 'copytrade.common.unknown-error';
        if ((error as any).em) {
            message = (error as any).em
        } else {
            message = (error as any).ec
        }
        toast.error(<CustomToast titleId={title} type={"ERROR"} message={message} messageId={messageId} time={new Date()} trackLogId={(error as any)?.tracerId ?? ''} />, {
            position: ToastPosition.BOTTOM_RIGHT,
            pauseOnHover: true,
            autoClose: autoCloseDelay
        });
    }

    static show(type: string, title: string, message?: string | any[], rawMessage = false, autoCloseDelay = 5000) {
        const content = <CustomToast type={type} titleId={title} messageId={rawMessage ? null : message} message={rawMessage ? message : null} time={new Date()} />;
        const options = {
            position: ToastPosition.BOTTOM_RIGHT,
            pauseOnHover: true,
            autoClose: autoCloseDelay
        };

        switch (type) {
            case TYPE_SUCCESS:
                toast.success(content, options);
                break;
            case TYPE_INFO:
                toast.info(content, options);
                break;
            case TYPE_WARN:
                toast.warn(content, options);
                break;
            case TYPE_ERROR:
                toast.error(content, options);
                break;
            default:
                break;
        }
    }
}

export default ToastUtil;